import { render, staticRenderFns } from "./ModulesMarquee.vue?vue&type=template&id=73b56778"
import script from "./ModulesMarquee.vue?vue&type=script&lang=js"
export * from "./ModulesMarquee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports